import { render } from "./new-delivery-address.vue?vue&type=template&id=2672118d"
import script from "./new-delivery-address.vue?vue&type=script&lang=js"
export * from "./new-delivery-address.vue?vue&type=script&lang=js"

import "./new-delivery-address.vue?vue&type=style&index=0&id=2672118d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__